import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

import { cn } from '../../utils/cn'
import { Button } from './button'

export function CopyButton({ value, className }: { value: string; className?: string }) {
  const [copied, setCopied] = useState(false)
  return (
    <Button
      type="button"
      variant="iconOnly"
      className={cn(
        'text-muted-foreground hover:text-foreground inline-flex size-5 shrink-0 items-center justify-center rounded hover:bg-neutral-100',
        className
      )}
      title={copied ? 'Copied' : 'Copy to clipboard'}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        void navigator.clipboard.writeText(value).then(() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 1200)
        })
      }}
    >
      {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
    </Button>
  )
}
